/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function Ignore16(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'Ignore16',
      'aria-hidden': true,
      focusable: false,
      width:  16 * scale,
      height: 16 * scale,
      viewBox: '0 0 16 16',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"fillRule":"evenodd","clipRule":"evenodd","d":"M4.884 6.334a2.6 2.6 0 0 0-.034.416v1.015c0 .623-.189 1.235-.545 1.77l-.773 1.158a.19.19 0 0 0-.003.204.23.23 0 0 0 .196.103H9.55zm6.338 2.096a3 3 0 0 1-.072-.665V6.75c0-1.281-.95-2.365-2.25-2.714V3.31c0-.447-.404-.81-.9-.81-.497 0-.9.363-.9.81v.726q-.105.028-.208.063l4.33 4.33zM6 12c.358.883 1.117 1.5 2 1.5s1.642-.617 2-1.5z","fill":"currentColor"}),createElement('path', {"d":"m13.565 12.186-9.78-9.78-.708.707 9.78 9.78z","fill":"currentColor"}))
}
